// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/servicos_categorias/delete
 *
 * Returns null `dados` on success — the legacy shape emits an empty payload.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicosCategorias_DeleteResponseDados = null;

export type ServicosCategorias_DeleteResponse = ApiResponse<ServicosCategorias_DeleteResponseDados>;

registerResponseContract('ServicosCategorias_DeleteResponse', {})
